import { personInfoFrag } from '../../../../../../utils/type/person.common-type';

export const clientsWithoutRecentWorkFrag = `
    id
    folderId
    serviceId
    personId
    person {
        ${personInfoFrag}
    }
    lastWorkAt
`;
